<template lang="pug">
  modal(
    name="confirm-dialog"
    :width="480"
    :height="260"
    :adaptive="true"
    :reset="true"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  )
    .confirm-dialog
      .confirm-title {{ title }}
      .confirm-message(v-if="message") {{ message }}
      .confirm-actions
        button.confirm-button.no(type="button" @click="onNo") {{ noLabel }}
        button.confirm-button.yes(type="button" @click="onYes") {{ yesLabel }}
</template>
<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      title: '',
      message: '',
      yesLabel: 'はい',
      noLabel: 'いいえ',
      resolve: null,
      settled: false,
    }
  },
  methods: {
    beforeOpen(event) {
      const params = (event && event.params) || {}
      this.title = params.title || ''
      this.message = params.message || ''
      this.yesLabel = params.yesLabel || 'はい'
      this.noLabel = params.noLabel || 'いいえ'
      this.resolve =
        typeof params.resolve === 'function' ? params.resolve : null
      this.settled = false
    },
    beforeClose() {
      this.settle(false)
    },
    onNo() {
      this.settle(false)
      this.$modal.hide('confirm-dialog')
    },
    onYes() {
      this.settle(true)
      this.$modal.hide('confirm-dialog')
    },
    settle(result) {
      if (this.settled) {
        return
      }
      this.settled = true
      if (this.resolve) {
        this.resolve(result)
        this.resolve = null
      }
    },
  },
}
</script>
<style scoped lang="scss">
.confirm-dialog {
  padding: 28px 24px;
  text-align: center;
  background: #fff;
}

.confirm-title {
  font-size: 20px;
  font-weight: bold;
  color: $base-color;
}

.confirm-message {
  margin-top: 12px;
  font-size: 14px;
  color: $base-color;
  word-break: break-word;
}

.confirm-actions {
  margin-top: 28px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.confirm-button {
  min-width: 120px;
  border-radius: 22px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: bold;
  border: 1px solid $base-brand-color;

  &.no {
    color: $base-brand-color;
    background: #fff;
  }

  &.yes {
    color: #fff;
    background: $base-brand-color;
  }
}
</style>
